<template>
  <active-button
    class="hide-button"
    :class="{
      'compact-hide-button': props.compact
    }"
    :title="$t('common.' + command)"
    @click="click"
  >
    <div class="text">{{ $t('common.hide') }}</div>
    <arrow-icon
      :direction="props.compact ? 'right' : 'left'"
      :title="$t('common.' + command)"
    ></arrow-icon>
  </active-button>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import ArrowIcon from '@/components/icons/ArrowIcon'

export default {
  components: {
    ActiveButton,
    ArrowIcon
  },
  props: {
    compact: Boolean
  },
  data () {
    return {
      command: this.compact ? 'show' : 'hide',
      props: {
        compact: this.compact
      }
    }
  },
  methods: {
    click () {
      this.command = [ 'hide', 'show' ][[ 'show', 'hide' ].indexOf(this.command)]
      this.props.compact = !this.props.compact
      this.$emit('toggle', this.props.compact)
    }
  }
}
</script>

<style scoped>
.hide-button { box-sizing: content-box; cursor: pointer; display: flex; height: 40px; line-height: 40px; margin-left: -10px; padding-left: 10px; position: relative; width: 100%; }
.compact-hide-button { padding-left: 0; width: 40px; }
.text { flex: 1 1; text-align: right; }
.compact-hide-button .text { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/buttons/MHideToggler.vue